<script setup>
definePage({
  meta: {
    layout: 'blank',
    requiresAuth: false,
  },
})
import Login from '../../views/dashboard/loginViews.vue'
</script>

<template>
  <VRow>
    <Login />
  </VRow>
</template>
